module.exports = __webpack_public_path__ + "static/media/img08.d04d26d8.JPG";